import {
  gql,
  InternalRefetchQueriesInclude,
  useMutation,
} from '@apollo/client';
import { Mutation, UpdateTenantInput } from 'generated/graphql';
import { useCallback } from 'react';
import { useGetUser } from 'v2/core/services/user';

const UPDATE_TENANT = gql`
  mutation updateTenant(
    $id: ID!
    $dashboardSettings: UpdateTenantDashboardSettingsInput
    $name: String
    $domains: [String!]
    $tier: TenantTier
    $avatarURL: String
    $timezone: String
    $state: TenantState
  ) {
    updateTenant(
      request: {
        id: $id
        dashboardSettings: $dashboardSettings
        name: $name
        domains: $domains
        tier: $tier
        avatarURL: $avatarURL
        timezone: $timezone
        state: $state
      }
    ) {
      code
      message
    }
  }
`;

interface UpdateTenantOptions {
  refetchQueries?: InternalRefetchQueriesInclude;
}

export const useUpdateTenant = (options?: UpdateTenantOptions) => {
  const { refetchQueries } = options ?? {};

  const {
    tenant: { id: tenantID },
  } = useGetUser();

  const [updateTenantMutation, { data, loading }] = useMutation<
    Mutation,
    UpdateTenantInput
  >(UPDATE_TENANT, {
    notifyOnNetworkStatusChange: true,
    variables: {
      id: tenantID,
    },
    refetchQueries,
  });

  const updateTenant = useCallback(
    async (input: Omit<UpdateTenantInput, 'id'>) => {
      await updateTenantMutation({
        variables: {
          ...input,
          id: tenantID,
        },
      });
    },
    [tenantID, updateTenantMutation],
  );

  return {
    updateTenant,
    data,
    loading,
  };
};
